import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, ArrowRight, ShieldAlert, Sparkles } from 'lucide-react';
import { siteConfig } from '../data';

export default function AnnouncementBar() {
  return (
    <div className="bg-[#09223D] text-white border-b border-white/10 text-xs sm:text-sm relative z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-2.5 lg:gap-6">
          
          {/* Nyhed om datalæk */}
          <div className="flex items-center gap-2.5 text-center lg:text-left justify-center lg:justify-start min-w-0">
            <span className="inline-flex items-center gap-1.5 bg-red-600/90 text-white font-bold px-2 py-0.5 text-[11px] uppercase tracking-wider shrink-0 rounded-sm">
              <span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse" />
              Seneste nyt
            </span>

            <div className="flex items-center gap-1.5 text-slate-100 text-xs sm:text-sm font-medium">
              <ShieldAlert className="w-4 h-4 text-[#c80306] shrink-0 hidden sm:inline" />
              <span>
                <span className="text-white font-semibold">Massivt datalæk:</span> Op mod 8,8 mio. cpr-numre lækket
              </span>
              <Link
                to="/vidensbank/massivt-datalaek-saadan-beskytter-du-dig"
                className="text-[#c80306] hover:text-white underline decoration-[#c80306]/60 underline-offset-2 ml-1 text-xs shrink-0 hidden sm:inline-flex items-center gap-0.5"
              >
                Læs råd
                <ArrowRight className="w-3 h-3" />
              </Link>
            </div>
          </div>

          {/* Første samtale og kontakt */}
          <div className="flex items-center gap-3 sm:gap-4 justify-center shrink-0">
            <div className="flex items-center gap-2 text-xs text-slate-200 bg-white/5 border border-white/10 px-3 py-1 rounded-sm">
              <Sparkles className="w-3.5 h-3.5 text-[#c80306] shrink-0" />
              <span>
                Første samtale (ca. 10-15 min):{' '}
                <span className="text-[#c80306] font-bold text-sm">99,-</span>
              </span>
            </div>

            <a
              href={`tel:${siteConfig.phone.replace(/\s/g, '')}`}
              className="inline-flex items-center gap-1.5 bg-red-600 hover:bg-red-700 text-white font-bold px-3 py-1 text-xs rounded-sm transition-colors shadow-sm"
            >
              <Phone className="w-3 h-3 fill-white" />
              <span>Ring {siteConfig.phone}</span>
            </a>
          </div>

        </div>
      </div>
    </div>
  );
}
